export const installmentTypes = {
  GET_INSTALLMENT_LIST: "GET_INSTALLMENT_LIST",
  GET_INSTALLMENT_DETAIL: "GET_INSTALLMENT_DETAIL",
  GET_INTEREST_RATE_LIST: "GET_INTEREST_RATE_LIST",
};